export enum CardFlagType {
    VISA = 1,
    MASTER = 2,
    ELO = 3
};

export class Pagamento {
    public additionalValue: Number;
    public cardholdercpf: String;
    public cardholdername: String;
    public cardnumber: String;
    public cardhash: String; // hash do cpf + numero do cartao
    public cvv: String;
    public expiremonth: String;
    public expireyear: String;
    public cardflag: CardFlagType;
};
